import lf from 'lovefield'

export function const_usagesengins (schemaBuilder) {
  schemaBuilder.createTable('const_usagesengins')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('const_sols_id', lf.Type.INTEGER)
      .addColumn('const_humidites_id', lf.Type.INTEGER)
      .addColumn('const_famillesengins_const_options_const_phases_id', lf.Type.INTEGER)
      .addColumn('utilisation', lf.Type.STRING)
      .addColumn('commentaire', lf.Type.STRING)
}

/*
CREATE TABLE `const-usagesengins` (
  `const-sols_code` varchar(4) NOT NULL,
  `const-humidites_code` varchar(10) NOT NULL,
  `const-famillesengins_const-options_const-phases_id` int(11) NOT NULL,
  `usage` varchar(2) NOT NULL
) ENGINE=InnoDB DEFAULT CHARSET=utf8;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/constUsagesEngins.schema.js